import React, { createContext, useContext, useState } from 'react';
import { CycleData } from '../Surgery/oocyteRetrieval/OocyteRetrival.helper'; // Import CycleData type

interface CycleContextType {
  cycleId: number | null;
  selectedCycle: CycleData | null;
  cycleIdForFertility: number | null;
  setCycleIdForFertility: (id: number | null) => void;
  setCycleId: (id: number | null) => void;
  setSelectedCycle: (cycle: CycleData | null) => void;

  // New addition
  surgeryCycleId: number | null;
  setSurgeryCycleId: (id: number | null) => void;
}

// Create context with default values
const CycleContext = createContext<CycleContextType | undefined>(undefined);

// Provider Component
export const CycleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [cycleId, setCycleId] = useState<number | null>(null);
  const [cycleIdForFertility, setCycleIdForFertility] = useState<number | null>(null);
  const [selectedCycle, setSelectedCycle] = useState<CycleData | null>(null);

  // New state for surgery-specific cycle
  const [surgeryCycleId, setSurgeryCycleId] = useState<number | null>(null);

  return (
    <CycleContext.Provider
      value={{
        cycleId,
        selectedCycle,
        cycleIdForFertility,
        setCycleId,
        setCycleIdForFertility,
        setSelectedCycle,
        surgeryCycleId,
        setSurgeryCycleId,
      }}
    >
      {children}
    </CycleContext.Provider>
  );
};

// Custom hook to use the context
export const useCycle = () => {
  const context = useContext(CycleContext);
  if (!context) {
    throw new Error('useCycle must be used within a CycleProvider');
  }
  return context;
};
